<template>
  <div>
    <h1
      v-if="service"
      class="title"
    >
      {{ service.label }}
    </h1>
    <CategoryList
      v-if="items"
      :items="items"
    />
    <div v-else-if="!isLoading">{{ $t('msg["Data is empty"]') }}</div>
  </div>
</template>
<script>
import { Category } from '@/api'
import CategoryList from '@/components/organisms/CategoryList'

export default {
  components: {
    CategoryList,
  },

  data() {
    return {
      service: null,
      items: [],
    }
  },

  async created() {
    await this.setCategory({ withChildren: true })
  },

  methods: {
    async setCategory(params = {}) {
      const params_copied = { ...params }
      this.$store.dispatch('setLoading', true)
      try {
        const res = await Category.get(this.serviceId, 'root', params_copied, this.userToken)
        this.service = res.meta.service
        this.items = res.item.children
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        this.debugOutput(err)
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },
  },
}
</script>
